import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';

import Button from '../../components/Button';
import Chart from '../../charts/Chart';
import 'highcharts/modules/wordcloud';

import { THEMES_DARK, useTheme, WORD_CLOUD_COLORS } from '../../helpers';
import { buildWordCloudChartOptions, shuffleCopy } from './utilities/helpers';

import { RepromptIcon } from '@utilities/icons';

import styles from '../Chart/_index.module.scss';

const WordCloud = ({ data }) => {
  const theme = useTheme();
  const [wordCloudSeed, setWordCloudSeed] = useState(1);

  const wordCloudColors =
    theme === THEMES_DARK.value ? WORD_CLOUD_COLORS.dark : WORD_CLOUD_COLORS.light;
  const wordCloudFreqMin = 3;

  const handleReroll = () => {
    setWordCloudSeed((seed) => seed + 1);
  };

  const filteredData = useMemo(() => {
    const baseData = data
      .filter((point) => point.weight >= wordCloudFreqMin)
      .map((point, index) => ({
        ...point,
        color: wordCloudColors[index % wordCloudColors.length],
      }));

    return wordCloudSeed === 1 ? baseData : shuffleCopy(baseData, wordCloudSeed);
  }, [data, wordCloudColors, wordCloudFreqMin, wordCloudSeed]);

  const chartOptions = buildWordCloudChartOptions({
    data: filteredData,
    seriesOptions: {
      custom: {
        seed: wordCloudSeed,
      },
    },
    tooltipEnabled: true,
  });

  return (
    <Chart
      chartTitle={`Word Cloud - ${filteredData.length} Words`}
      className={styles['chart-word-cloud']}
      headerActions={
        <Button
          aria-label="Reroll Word Cloud"
          icon={<RepromptIcon />}
          onClick={handleReroll}
          text=""
          title="Reroll Word Cloud"
          variant="secondary"
        />
      }
      key={wordCloudSeed}
      options={chartOptions}
    />
  );
};

WordCloud.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      weight: PropTypes.number.isRequired,
    })
  ).isRequired,
};

export default WordCloud;
